
const agreementIndex = resolve => require(['@/views/agreement/index.vue'], resolve)// 主页

export default [{
  path: '/agreement',
  component: agreementIndex
}
]
